import { Box } from '@mui/material';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import type { JSX } from 'react';

export const Route = createFileRoute('/_public/_empty')({
  component: EmptyLayout,
});

function EmptyLayout(): JSX.Element {
  return (
    <Box component="main">
      <Outlet />
    </Box>
  );
}
